"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.WarningBanner = exports.UnavailableToScheduleBanner = exports.SchedulingHelpBanner = exports.RegulatedSpacesBanner = exports.NoResultsBanner = exports.NoOnlineBookingBanner = exports.InfoBanner = exports.ErrorBookingBanner = exports.EmergencyBanner = exports.DeepLinkingUnavailableSlotBanner = exports.CallToBookBanner = exports.AppointmentUnavailableBanner = exports.AlertBanner = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _framerMotion = require("framer-motion");
var _intl = require("@kyruus/intl");
var _button = _interopRequireWildcard(require("@kyruus/button"));
var _banner = _interopRequireDefault(require("@kyruus/banner"));
var _Cancel = _interopRequireDefault(require("@kyruus/react-ikons/Cancel"));
var _messages = _interopRequireDefault(require("../../lib/messages"));
var _Filters = require("../../lib/constants/Filters");
var _styles = require("./styles");
var _PhoneNumberLink = _interopRequireDefault(require("../PhoneNumberLink/PhoneNumberLink"));
var _utils = require("../../lib/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const InfoBanner = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_banner.default, (0, _extends2.default)({}, props, {
    type: "info",
    icon: "i"
  }), children);
};
exports.InfoBanner = InfoBanner;
const AlertBanner = _ref2 => {
  let {
    children,
    onClose,
    ...props
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_banner.default, (0, _extends2.default)({}, props, {
    type: "alert",
    icon: "!",
    action1Text: /*#__PURE__*/_react.default.createElement(_Cancel.default, null),
    action1: "close",
    onClose: onClose
  }), children);
};
exports.AlertBanner = AlertBanner;
const WarningBanner = _ref3 => {
  let {
    children,
    ...props
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(_banner.default, (0, _extends2.default)({}, props, {
    icon: "!",
    type: "warning"
  }), children);
};
exports.WarningBanner = WarningBanner;
const EmergencyBanner = _ref4 => {
  let {
    children,
    onClose
  } = _ref4;
  return /*#__PURE__*/_react.default.createElement(AlertBanner, {
    "data-testid": "EmergencyBanner",
    onClose: onClose
  }, children);
};
exports.EmergencyBanner = EmergencyBanner;
const NoOnlineBookingBanner = exports.NoOnlineBookingBanner = (0, _intl.injectIntl)(_ref5 => {
  let {
    intl,
    patientRel,
    providerName,
    phone,
    ...props
  } = _ref5;
  // Have to couple mountscrolling because intlV2 doesn't support ref forwarding.
  // TODO: Use MountScroller if we ever upgrade to intlV3

  // Create the ref to pass to the child
  const ref = /*#__PURE__*/_react.default.createRef();

  // Scroll the child into view only on mount
  _react.default.useEffect(() => {
    ref.current.scrollIntoView && ref.current.scrollIntoView(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(WarningBanner, (0, _extends2.default)({
    "data-testid": "NoOnlineBookingBanner"
  }, props), /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, (0, _extends2.default)({}, _messages.default.noapptpurposes, {
    values: {
      provider_name: providerName,
      patient_status: patientRel === _Filters.NEW_PATIENT ? intl.formatMessage(_messages.default.new) : intl.formatMessage(_messages.default.established)
    }
  })), /*#__PURE__*/_react.default.createElement("br", null), phone && /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, (0, _extends2.default)({}, _messages.default.contactoffice, {
    values: {
      phone_number_link: /*#__PURE__*/_react.default.createElement(_PhoneNumberLink.default, {
        phone: phone
      })
    }
  }))));
});
const CallToBookBanner = _ref6 => {
  let {
    phone
  } = _ref6;
  return /*#__PURE__*/_react.default.createElement(WarningBanner, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, (0, _extends2.default)({}, _messages.default.contactPhone, {
    values: {
      phone_number_link: /*#__PURE__*/_react.default.createElement(_PhoneNumberLink.default, {
        phone: phone
      })
    }
  })));
};
exports.CallToBookBanner = CallToBookBanner;
const ErrorBookingBanner = _ref7 => {
  let {
    phone
  } = _ref7;
  return /*#__PURE__*/_react.default.createElement(WarningBanner, {
    "data-testid": "ErrorBookingBanner"
  }, phone ? /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, (0, _extends2.default)({}, _messages.default.bookApptError, {
    values: {
      phone_number_link: /*#__PURE__*/_react.default.createElement(_PhoneNumberLink.default, {
        phone: phone
      })
    }
  })) : /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.bookApptErrorNoPhone));
};
exports.ErrorBookingBanner = ErrorBookingBanner;
const UnavailableToScheduleBanner = _ref8 => {
  let {
    phone
  } = _ref8;
  return /*#__PURE__*/_react.default.createElement(WarningBanner, {
    "data-testid": "UnavailableToScheduleBanner"
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.bookApptUnavailableToSchedule), phone && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, (0, _extends2.default)({}, _messages.default.contactoffice, {
    values: {
      phone_number_link: /*#__PURE__*/_react.default.createElement(_PhoneNumberLink.default, {
        phone: phone
      })
    }
  }))));
};
exports.UnavailableToScheduleBanner = UnavailableToScheduleBanner;
const AppointmentUnavailableBanner = () => /*#__PURE__*/_react.default.createElement(WarningBanner, {
  "data-testid": "AppointmentUnavailableBanner"
}, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.apptUnavailableError));
exports.AppointmentUnavailableBanner = AppointmentUnavailableBanner;
const DeepLinkingUnavailableSlotBanner = exports.DeepLinkingUnavailableSlotBanner = (0, _intl.injectIntl)(_ref9 => {
  let {
    slotTime
  } = _ref9;
  return /*#__PURE__*/_react.default.createElement(WarningBanner, {
    "data-testid": "DeepLinkingUnavailableSlotBanner"
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, (0, _extends2.default)({}, _messages.default.deepLinkingUnavailableSlotError, {
    values: {
      appt_time: slotTime
    }
  })));
});
const SchedulingHelpBanner = _ref10 => {
  let {
    phone,
    track
  } = _ref10;
  if (!phone) return null;
  return /*#__PURE__*/_react.default.createElement(InfoBanner, {
    "data-testid": "SchedulingHelpBanner"
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, (0, _extends2.default)({}, _messages.default.schedulingHelp, {
    values: {
      phone_number_link: /*#__PURE__*/_react.default.createElement(_PhoneNumberLink.default, {
        phone: phone,
        onClick: () => {
          track('user_action.direct_book.need_help_box.phone_link');
        }
      })
    }
  })));
};
exports.SchedulingHelpBanner = SchedulingHelpBanner;
const NoResultsBanner = _ref11 => {
  let {
    jumpedToDate,
    date,
    isLoading,
    onClearFilters,
    onLoadMore,
    resultsMessage
  } = _ref11;
  const formattedDate = (0, _utils.formatLastApptShownDate)(date);
  const formattedJumpToDate = (0, _utils.formatLastApptShownDate)(jumpedToDate);
  return /*#__PURE__*/_react.default.createElement(_styles.NoResultsContainer, {
    "data-testid": "NoResultsBanner"
  }, /*#__PURE__*/_react.default.createElement(InfoBanner, null, /*#__PURE__*/_react.default.createElement(_styles.NoResultsContent, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, (0, _extends2.default)({}, resultsMessage, {
    values: {
      jumpedToDate: /*#__PURE__*/_react.default.createElement(_framerMotion.AnimatePresence, null, /*#__PURE__*/_react.default.createElement(_framerMotion.motion.strong, {
        key: formattedJumpToDate,
        initial: {
          opacity: 0
        },
        animate: {
          opacity: 1
        },
        exit: {
          opacity: 0
        }
      }, formattedJumpToDate)),
      date: /*#__PURE__*/_react.default.createElement(_framerMotion.AnimatePresence, null, /*#__PURE__*/_react.default.createElement(_framerMotion.motion.strong, {
        key: formattedDate,
        initial: {
          opacity: 0
        },
        animate: {
          opacity: 1
        },
        exit: {
          opacity: 0
        }
      }, formattedDate))
    },
    key: "message"
  }))), /*#__PURE__*/_react.default.createElement("section", null, isLoading ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_button.default, {
    "data-testid": "clearBtn",
    disabled: true
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.noFilteredResultsClearBtn)), /*#__PURE__*/_react.default.createElement(_button.ButtonWithSpinner, {
    showSpinner: true,
    disabled: true
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.noFilteredResultsLoadMoreBtn))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, onClearFilters != null && /*#__PURE__*/_react.default.createElement(_button.default, {
    onClick: onClearFilters
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.noFilteredResultsClearBtn)), onLoadMore != null && /*#__PURE__*/_react.default.createElement(_button.default, {
    onClick: onLoadMore
  }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.noFilteredResultsLoadMoreBtn)))))));
};
exports.NoResultsBanner = NoResultsBanner;
const RegulatedSpacesBanner = exports.RegulatedSpacesBanner = (0, _intl.injectIntl)(_ref12 => {
  let {
    intl,
    location,
    track = () => {}
  } = _ref12;
  if (location.email) {
    return /*#__PURE__*/_react.default.createElement(_styles.StyledRegulatedSpacesBanner, {
      icon: "!",
      type: "warning"
    }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, (0, _extends2.default)({}, _messages.default.regulatedSpacesBannerWithLink, {
      values: {
        regulated_spaces_link: /*#__PURE__*/_react.default.createElement(_styles.RegulatedSpacesLink, {
          title: intl.formatMessage(_messages.default.regulatedSpacesBannerLinkTitle, {
            location_name: location.name
          }),
          href: location.email,
          onClick: () => {
            track('user_action.direct_book.regulated_spaces_link_click');
          },
          rel: "noopener noreferrer",
          target: "_blank"
        }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.clickHere))
      }
    })));
  } else {
    return /*#__PURE__*/_react.default.createElement(_styles.StyledRegulatedSpacesBanner, {
      icon: "!",
      type: "warning"
    }, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.regulatedSpacesBanner));
  }
});
InfoBanner.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "InfoBanner"
};
AlertBanner.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AlertBanner"
};
WarningBanner.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "WarningBanner"
};
EmergencyBanner.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "EmergencyBanner"
};
CallToBookBanner.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CallToBookBanner"
};
ErrorBookingBanner.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ErrorBookingBanner"
};
UnavailableToScheduleBanner.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "UnavailableToScheduleBanner"
};
AppointmentUnavailableBanner.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppointmentUnavailableBanner"
};
SchedulingHelpBanner.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SchedulingHelpBanner"
};
NoResultsBanner.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "NoResultsBanner"
};